import { render, staticRenderFns } from "./newSearch.vue?vue&type=template&id=b8246c6c&scoped=true&"
import script from "./newSearch.vue?vue&type=script&lang=js&"
export * from "./newSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8246c6c",
  null
  
)

export default component.exports